import { useCallback } from "react";
import apiClient from "../../../helpers/apiClient";
import { buildCarImagesPayload, uploadCheckInImageFiles } from "../../checkin/utils/checkInImageHelpers";
import buildCheckOutReservationPatch from "../utils/checkOutOut";
import i18n from "../../../config/i18_init";

export default function useCheckOutSubmit() {
    const submitCheckOut = useCallback(async (reservation, data, toast) => {
        if (!reservation?.id) {
            throw new Error("Reservation ID is required");
        }

        try {
            const uploaded = await uploadCheckInImageFiles({
                walkaroundFiles: data.walkaroundFiles,
                dashboardFile: data.dashboardFile,
            });

            const carImages = buildCarImagesPayload(uploaded);
            const patchPayload = buildCheckOutReservationPatch({
                carImages,
                fuelLevel: data.fuelLevel,
                mileage: data.mileage,
            });

            await apiClient.patch(`/api/reservation/${reservation.id}`, patchPayload);
        } catch (error) {
            toast.error({
                message: i18n.t("checkOut:checkOutFailedTitle"),
                description: error?.response?.data?.message || error?.message || i18n.t("checkOut:checkOutFailed"),
            });
            throw error;
        }
    }, []);

    return { submitCheckOut };
}
